import { useState, useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Typography } from 'antd'
import { CheckOutlined } from "@ant-design/icons";
import ArmsAndCohorts from '../ArmsAndCohorts/ArmsAndCohorts'
import { getGetReferenceData } from 'src/utils/ajax-proxy'
import StudyPopulation from '../StudyPopulation'
import ScheduleOfActivity from '../ScheduleOfActivity'
import Endpoints from '../Endpoints'
import { TRIAL_ALIAS_STYLE } from 'src/constants/index'
import { useSelector } from 'react-redux'
import { fetchHistory } from 'src/actions/historyTrial'
import { useMarkAsCompleteHooks } from 'src/DigitalProtocolModule/hooks';
import styles from './index.module.scss'

const { Text } = Typography;

export default function DprotocolSections() {
  const location = useLocation()
  const history = useHistory()

  const trialDetail = JSON.parse(localStorage.getItem('trial-detail'))

  const finalizeStatus = useSelector(fetchHistory).data?.dpFinalizeStatus;

  const { getSectionLockStatus } = useMarkAsCompleteHooks();

  const tabsRef = useRef<any[]>([
    {
      tabName: "Study Population",
      mappingProp: "study_population_finalize_flag",
      onClick: () => history.replace("/dprotocol/study-population"),
      activeTabKey: "0",
    },
    {
      tabName: "Arms & Cohorts",
      mappingProp: "arm_cohort_finalize_flag",
      onClick: () => history.replace("/dprotocol/arms-cohorts"),
      activeTabKey: "1",
    },
    {
      tabName: "Schedule of Activities",
      mappingProp: "soa_finalize_flag",
      onClick: () => history.replace("/dprotocol/soa"),
      activeTabKey: "2",
    },
    {
      tabName: "Endpoints",
      mappingProp: "endpoint_finalize_flag",
      onClick: () => history.replace("/dprotocol/endpoints"),
      activeTabKey: "3",
    },
  ]);

  const [activeTabKey, setActiveTabKey] = useState<string>("");
  const [indications, setIndications] = useState<string[]>([]);

  const backToDpLanding = () => {
    history.replace('/dprotocol')
  }

  const fetchRefData = async () => {
    try {
      const res = await getGetReferenceData()
      if (res?.indication_list) {
        const tmpIndications = res?.indication_list
          .filter((item) => trialDetail?.indication?.includes(item.value))
          .map((item) => item.label)
        setIndications(tmpIndications)
      }
    } catch (error) {}
  }

  useEffect(() => {
    switch (location.pathname) {
      case '/dprotocol/study-population':
        setActiveTabKey('0')
        break
      case '/dprotocol/arms-cohorts':
        setActiveTabKey('1')
        break    
      case '/dprotocol/soa':
        setActiveTabKey('2')
        break
      case '/dprotocol/endpoints':
        setActiveTabKey('3')
        break  
      default:
        break;
    }
  }, [location])

  useEffect(() => {
    if (trialDetail?.indication?.length > 0) {
      fetchRefData()
    }
    // get lock status for all sections
    getSectionLockStatus();
  }, [])

  return (
    <>
      <div className={styles.header}>
        <Text
          underline={true}
          style={{maxWidth: TRIAL_ALIAS_STYLE.width, fontSize: TRIAL_ALIAS_STYLE.fontSize, color: TRIAL_ALIAS_STYLE.color}}
          className={styles.pageTitle}
          ellipsis={
            trialDetail?.trial_alias.length > 70
              ? { tooltip: trialDetail?.trial_alias }
              : {}
          }
          onClick={backToDpLanding}
        >
          {trialDetail?.trial_alias}
        </Text>

        <div className={styles.infoLine}>
          <div className={styles.label}>INDICATION</div>
          <div className={styles.value}>{indications.join(', ')}</div>
        </div>
      </div>

      <div className={styles.tabsContainer}>
        {tabsRef.current.map((tabItem) => (
          <div
            className={`${styles.activeTabName} ${
              activeTabKey === tabItem.activeTabKey ? styles.active : ""
            }`}
            onClick={tabItem.onClick}
            key={tabItem.tabName}
          >
            <div className={styles.nameStatus}>
              <span className="tab-Name">{tabItem.tabName}</span>
              {finalizeStatus[tabItem.mappingProp] && (
                <CheckOutlined className={styles.check}/>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.bodyWrapper}>
        {activeTabKey === "0" ? (
          <StudyPopulation />
        ) : activeTabKey === "1" ? (
          <ArmsAndCohorts />
        ) : activeTabKey === "2" ? (
          <ScheduleOfActivity />
        ) : activeTabKey === "3" ? (
          <Endpoints />
        ) : null}
      </div>
    </>
  )
}
